import { render, staticRenderFns } from "./LandingPagePreviewTwo.vue?vue&type=template&id=521396ec&scoped=true&"
import script from "./LandingPagePreviewTwo.vue?vue&type=script&lang=js&"
export * from "./LandingPagePreviewTwo.vue?vue&type=script&lang=js&"
import style0 from "./LandingPagePreviewTwo.vue?vue&type=style&index=0&id=521396ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521396ec",
  null
  
)

export default component.exports